// AUTO-GENERATED - do not edit.
// Source: business/ishvaram/data/registry/runtime_contracts.yaml

export const webPublicRuntimeEnvKeys = [
  "NEXT_PUBLIC_API_URL",
  "NEXT_PUBLIC_CHAT_STREAMING_ENABLED",
  "NEXT_PUBLIC_CHAT_OFFER_MOMENT_ENABLED",
  "NEXT_PUBLIC_CHAT_USE_VERCEL_SDK",
  "NEXT_PUBLIC_MEMBERSHIP_ENABLED",
  "NEXT_PUBLIC_SUPABASE_URL",
  "NEXT_PUBLIC_SUPABASE_ANON_KEY",
  "NEXT_PUBLIC_GTM_ID",
  "NEXT_PUBLIC_GA_MEASUREMENT_ID",
  "NEXT_PUBLIC_SENTRY_DSN",
  "NEXT_PUBLIC_SUPPORT_WHATSAPP",
  "NEXT_PUBLIC_META_PIXEL_ID",
  "NEXT_PUBLIC_TURNSTILE_SITEKEY",
  "NEXT_PUBLIC_VAPID_PUBLIC_KEY",
  "NEXT_PUBLIC_VALUE_MOMENT_CAPTURE",
] as const;

export const webServerRuntimeEnvKeys = ["SUPABASE_SERVICE_ROLE_KEY"] as const;

export const webPublicRuntimeEnv = {
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_CHAT_STREAMING_ENABLED: process.env.NEXT_PUBLIC_CHAT_STREAMING_ENABLED,
  NEXT_PUBLIC_CHAT_OFFER_MOMENT_ENABLED: process.env.NEXT_PUBLIC_CHAT_OFFER_MOMENT_ENABLED,
  NEXT_PUBLIC_CHAT_USE_VERCEL_SDK: process.env.NEXT_PUBLIC_CHAT_USE_VERCEL_SDK,
  NEXT_PUBLIC_MEMBERSHIP_ENABLED: process.env.NEXT_PUBLIC_MEMBERSHIP_ENABLED,
  NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  NEXT_PUBLIC_GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_SUPPORT_WHATSAPP: process.env.NEXT_PUBLIC_SUPPORT_WHATSAPP,
  NEXT_PUBLIC_META_PIXEL_ID: process.env.NEXT_PUBLIC_META_PIXEL_ID,
  NEXT_PUBLIC_TURNSTILE_SITEKEY: process.env.NEXT_PUBLIC_TURNSTILE_SITEKEY,
  NEXT_PUBLIC_VAPID_PUBLIC_KEY: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
  NEXT_PUBLIC_VALUE_MOMENT_CAPTURE: process.env.NEXT_PUBLIC_VALUE_MOMENT_CAPTURE,
} as const;

export const webServerRuntimeEnv = {
  SUPABASE_SERVICE_ROLE_KEY: process.env.SUPABASE_SERVICE_ROLE_KEY,
} as const;

export type WebPublicRuntimeEnvKey = (typeof webPublicRuntimeEnvKeys)[number];
export type WebServerRuntimeEnvKey = (typeof webServerRuntimeEnvKeys)[number];
